import { useIntl } from "react-intl";
import { useCallback } from "react";
import SweetAlert, { SweetAlertOptions } from "sweetalert2";
import { ExtraModalAction, ExtraModalActionType } from "../types";
import { messages } from "../messages";
import { APP_COLORS } from "../../../witadmin/Common/constants";

export function useModal() {
  const intl = useIntl();

  const getModalPropsByAction = useCallback((action: ExtraModalAction): SweetAlertOptions => {
    switch (action.type) {
      case ExtraModalActionType.ERROR_GET_ONE:
        return {
          title: intl.formatMessage(messages.getOneErrorTitle),
          text: intl.formatMessage(messages.getOneErrorDescription),
          confirmButtonColor: APP_COLORS.primary,
          icon: "error",
        };
      case ExtraModalActionType.SUCCESS_CREATE:
        return {
          title: intl.formatMessage(messages.createSuccessTitle),
          text: intl.formatMessage(messages.createSuccessDescription),
          confirmButtonColor: APP_COLORS.primary,
          icon: "success",
        };
      case ExtraModalActionType.ERROR_CREATE:
        return {
          title: intl.formatMessage(messages.createErrorTitle),
          text: intl.formatMessage(messages.createErrorDescription),
          confirmButtonColor: APP_COLORS.primary,
          icon: "error",
        };
      case ExtraModalActionType.SUCCESS_UPDATE:
        return {
          title: intl.formatMessage(messages.updateSuccessTitle),
          text: intl.formatMessage(messages.updateSuccessDescription),
          confirmButtonColor: APP_COLORS.primary,
          icon: "success",
        };
      case ExtraModalActionType.ERROR_UPDATE:
        return {
          title: intl.formatMessage(messages.updateErrorTitle),
          text: intl.formatMessage(messages.updateErrorDescription),
          confirmButtonColor: APP_COLORS.primary,
          icon: "error",
        };
      case ExtraModalActionType.ERROR_GET_INVENTORY_LINES_EXCEL:
        return {
          title: intl.formatMessage(messages.getInventoryLinesExcelErrorTitle),
          text: intl.formatMessage(messages.getInventoryLinesExcelErrorDescription),
          confirmButtonColor: APP_COLORS.primary,
          icon: "error",
        };
      case ExtraModalActionType.ERROR_PROCESS_INVENTORY_LINES_EXCEL:
        return {
          title: intl.formatMessage(messages.processInventoryLinesExcelErrorTitle),
          text: intl.formatMessage(messages.processInventoryLinesExcelErrorDescription),
          confirmButtonColor: APP_COLORS.primary,
          icon: "error",
        };
      case ExtraModalActionType.ERROR_LOAD_PROPERTY_INVENTORY:
        return {
          title: intl.formatMessage(messages.loadPropertyInventoryErrorTitle),
          text: intl.formatMessage(messages.loadPropertyInventoryErrorDescription),
          confirmButtonColor: APP_COLORS.primary,
          icon: "error",
        };
      case ExtraModalActionType.ERROR_DOWNLOAD_ONE_TIME_PROMO_CODE_EXCEL:
        return {
          title: intl.formatMessage(messages.downloadOneTimePromoCodeExcelErrorTitle),
          text: intl.formatMessage(messages.downloadOneTimePromoCodeExcelErrorDescription),
          confirmButtonColor: APP_COLORS.primary,
          icon: "error",
        };
      case ExtraModalActionType.SUCCESS_PROCESS_ONE_TIME_PROMO_CODE_EXCEL:
        return {
          title: intl.formatMessage(messages.processOneTimePromoCodeExcelSuccessTitle),
          text: intl.formatMessage(messages.processOneTimePromoCodeExcelSuccessDescription),
          confirmButtonColor: APP_COLORS.primary,
          icon: "success",
        };
      case ExtraModalActionType.ERROR_PROCESS_ONE_TIME_PROMO_CODE_EXCEL:
        return {
          title: intl.formatMessage(messages.processOneTimePromoCodeExcelErrorTitle),
          text: intl.formatMessage(messages.processOneTimePromoCodeExcelErrorDescription),
          confirmButtonColor: APP_COLORS.primary,
          icon: "error",
        };
      default:
        throw new Error(`Invalid action ${action}`);
    }
  }, [intl]);

  const showModal = useCallback(async (action: ExtraModalAction, onConfirm: () => void) => {
    const result = await SweetAlert.fire(getModalPropsByAction(action));
    if (result.isConfirmed || result.isDismissed || result.isDenied) {
      onConfirm();
    }
  }, [getModalPropsByAction]);

  return { showModal }
}